import moment from 'moment';

export const timeFormat = {
  DATE: 'DD-MM-YYYY',
  TIME: 'DD-MM-YYYY HH:mm:ss',
  MINUTES: 'DD/MM/YYYY HH:mm',
  FILE_CREATED_AT: 'YYYYMMDD_HHmmss',
};

const formats = [
  timeFormat.DATE,
  timeFormat.TIME,
  moment.HTML5_FMT.DATETIME_LOCAL_MS,
  moment.ISO_8601,
];

export const isValidDate = string => moment(string, formats, true).isValid();

export const isSameDate = (date1, date2) => moment(date1, timeFormat.DATE).isSame(moment(date2, timeFormat.DATE))



// WEBPACK FOOTER //
// ./src/constants/time.js